import type { IQuizVersionRepository } from '@/core/domain/quiz/IQuizVersionRepository.ts'
import { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory.ts'
import type { QuizVersionEntity } from '@/core/infrastructure/schemas/quiz/QuizVersionSchemas.ts'

export class QuizVersionRepository implements IQuizVersionRepository {
  async fetchQuizVersionById(id: number): Promise<QuizVersion> {
    const response = await apiService.get<QuizVersionEntity>(`/quiz/versions/${id}`)
    return QuizVersion.create(response.data)
  }
}